export const TimesheetPrimaryGroupingType = Object.freeze({
  /**
   * Describes a grouping of the timesheets to be by client.
   */
  client: 'client',
  /**
   * Describes a grouping of the timesheets to be by candidate.
   */
  candidate: 'candidate',
})
